module.exports = require('./helpers/bundle-url').getBundleURL('25ay3') + "logo-dark.eefe0b7f.svg";